export default {
  ...require('./global.json'),
  ...require('./hzba.json'),
}